import { Eye, EyeOff } from 'lucide-react'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { PasswordValidation } from '@components/validation'
import { AdasBox, AdasButton, AdasInputAdornment, AdasTextField } from '@components/wrapper-components'
import { updateUserPassword } from '../../../../api/api'

export const PasswordForm = ({ user, close, onSaveSuccess }) => {
  const [newPassword, setNewPassword] = useState('')
  const [showPassword, setShowPassword] = React.useState(false)
  const [enableSave, setEnableSave] = useState(false)

  const handleValidationChange = (isValid) => {
    setEnableSave(isValid)
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    setNewPassword(value)
  }

  const handleSavePassword = () => {
    const data = { ...user, password: newPassword }
    const updateUserResponse = updateUserPassword({
      data: data
    })
    updateUserResponse.then((response) => {
      if (response.status === 200) {
        close()
        onSaveSuccess(data)
      }
    })
  }

  return (
    <>
      <AdasTextField
        placeholder='Password'
        type={showPassword ? 'text' : 'password'}
        id='password'
        label='Password'
        className='w-full pb-2'
        onChange={handleInputChange}
        InputProps={{
          endAdornment: (
            <AdasInputAdornment position='end'>
              <AdasButton
                buttonType='iconButton'
                aria-label='toggle password visibility'
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(evt) => evt.preventDefault()}
                edge='end'
              >
                {showPassword ? <EyeOff /> : <Eye />}
              </AdasButton>
            </AdasInputAdornment>
          )
        }}
      />
      <PasswordValidation password={newPassword} onValidationChange={handleValidationChange} />
      <AdasBox className='flex justify-end my-[20px] mx-0'>
        <AdasButton variant='outlined' aria-label='cancel' color='primary' onClick={close}>
          Cancel
        </AdasButton>
        <AdasButton
          type='submit'
          disabled={!enableSave}
          variant='contained'
          aria-label='save'
          color='primary'
          className='ml-2'
          onClick={handleSavePassword}
        >
          Save
        </AdasButton>
      </AdasBox>
    </>
  )
}

PasswordForm.propTypes = { user: PropTypes.object, close: PropTypes.func.isRequired, onSaveSuccess: PropTypes.func.isRequired }
